module.exports = "/assets/storybook/blog/blog-post-card-cover-image.jpg?rKnWsKu";